import { Formik, Form } from "formik";
import useTutorial from "../../../hooks/useTutorial";
import { BaSeInput, BaSeGrid, BaSeGridItem } from "@base/react";
import TitleWithPopover from "../../../components/title-with-popover";

const TutorialVariableIndirectCosts = () => {
  const PAGE_KEY = "custosIndiretosVariaveis";

  useTutorial({
    currentStep: "9",
    pageKey: "custosIndiretosVariaveis",
    previousKey: "mediaMensal",
    steps: [
      {
        element: ".variable-indirect-costs",
        popover: {
          title: "Custos Indiretos Variáveis",
          description: `Registre os custos variáveis do seu negócio, como taxas de cartão, comissões e impostos. Ter controle sobre
          esses valores ajuda a otimizar sua margem de lucro.`,
          side: "bottom",
          align: "center",
        },
        onHighlighted: () => {
          const sideBar = document.querySelector(".list-menu");
          if (sideBar) {
            sideBar.classList.remove("open");
          }
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["investimentoTotal"]) {
        tutorials["investimentoTotal"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div className="step variable-indirect-costs">
      <TitleWithPopover
        title="Custos Indiretos Variáveis"
        messagePopover="Estes são os custos que variam de acordo com as mudanças nas vendas, refletindo o impacto direto das vendas no seu negócio."
        size={5}
      />

      <Formik>
        {() => (
          <Form>
            <TitleWithPopover
              title="Taxa de cartão de débito"
              smallTitle="(média)"
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% Taxas"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% da Receita Total"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
            </BaSeGrid>

            <TitleWithPopover
              title="Taxa de cartão de crédito"
              smallTitle="(média)"
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% Taxas"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% da Receita Total"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
            </BaSeGrid>

            <TitleWithPopover title="Custos com comissões" />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% Taxas"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% da Receita Total"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
            </BaSeGrid>

            <TitleWithPopover title="Custos com impostos" />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% Taxas"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% da Receita Total"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
            </BaSeGrid>

            <TitleWithPopover title="Outros custos" />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% Taxas"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  inputMode="decimal"
                  typeInput="tel"
                  prefix="% "
                  maxLength={8}
                  size="medium"
                  placeholder="%"
                  label="% da Receita Total"
                  width="100%"
                  mask="decimal"
                  showHelpButton
                />
              </BaSeGridItem>
            </BaSeGrid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialVariableIndirectCosts;
